export const MONTH_TRANSACTIONS = 'monthTransactions';
export const MONTH_CHECK_HISTORY = 'monthCheckHistory';
export const TYPE = 'type';
export const SEARCH = 'searchValue';
export const STATUS = 'status';
export const initFilter = {
  [MONTH_TRANSACTIONS]: '',
  [TYPE]: '',
  [SEARCH]: '',
  [MONTH_CHECK_HISTORY]: '',
  [STATUS]: ''
};
